import CroustilleElement from "../lib/CroustilleElement";
import A11yDialog from "a11y-dialog";
import { scrollDirection, DIRECTION } from "../lib/scrollDirection";

const SCROLL_DOWN_THRESHOLD = 200;

class FamilyMemberBio extends CroustilleElement {
  constructor() {
    super("family-member-bio");
  }

  handleKeyDown(e) {
    const evt = e || window.event;
    if (evt.keyCode === 27) {
      this.dialog.hide();
    }
  }

  setVisibility(scrollY) {
    if (
      scrollY > SCROLL_DOWN_THRESHOLD &&
      scrollDirection() === DIRECTION.DOWN
    ) {
      this.close();
    }
  }

  trackVisibility() {
    const scrollY = window.scrollY;
    let ticking = false;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        this.setVisibility(scrollY);
        ticking = false;
      });

      ticking = true;
    }
  }

  init() {
    this.toggle = this.child("toggle");
    this.bio = this.child("bio");
    this.dialog = new A11yDialog(this.bio);
    this.show = () => {
      document.dispatchEvent(new Event("dialog:close"));
      this.dialog.show();
    };
    this._handleKeyDown = this.handleKeyDown.bind(this);
    this.close = () => this.dialog.hide();
    this._close = this.close.bind(this);

    this._trackVisibility = this.trackVisibility.bind(this);
    window.addEventListener("scroll", this._trackVisibility);

    document.addEventListener("dialog:close", this._close);
    document.addEventListener("barba", this._close);
    this.toggle.addEventListener("click", this.show);
    document.addEventListener("keydown", this._handleKeyDown);
  }

  destroy() {
    this.toggle.removeEventListener("click", this.show);
    document.removeEventListener("keydown", this._handleKeyDown);
  }
}

export default FamilyMemberBio;
